import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { defaults, RemDocsOptions } from '../@models/m-remdocs-options.config';

@Injectable({
  providedIn: 'root',
})
export class RemDocsCoreOptionsService {
  get notify(): Observable<Record<string, any>> {
    return this.notify$.asObservable();
  }

  private options = defaults;
  private notify$ = new BehaviorSubject<Record<string, any>>({});

  getOptions() {
    let LS_OPTIONS = localStorage.getItem('LS_REMDOCSOPTIONS') || '';
    if(LS_OPTIONS) {
      let _options = JSON.parse(LS_OPTIONS);
      if(_options && _options.mode) { 
        _options.mode = defaults.mode;
        this.options.mode = _options.mode;
        this.options.quickAccess = _options.quickAccess;
        this.options.envSettings = _options.envSettings;
      }
    }
    return this.options;
  }

  setOptions(options: RemDocsOptions) {
    this.options = Object.assign(defaults, options);
    this.notify$.next(this.options);
    localStorage.setItem('LS_REMDOCSOPTIONS', JSON.stringify(options));
  }

}